import React, { useState } from "react";
import down from "./assets/down.svg";
import icon from "./assets/icon.svg";
import up from "./assets/up.svg";

import {
  ChevronIcon,
  Container,
  Content,
  ContentText,
  Icon,
  Title,
  TitleWrapper,
  TopRow,
} from "./styles";

const BillCompensationBanner: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Container>
      <TopRow>
        <TitleWrapper>
          <Icon src={icon} alt="Ícone de informação" />
          <Title>Tempo de compensação do boleto</Title>
        </TitleWrapper>
        <ChevronIcon
          src={isExpanded ? up : down}
          onClick={() => setIsExpanded((v) => !v)}
          aria-label={isExpanded ? "Recolher" : "Expandir"}
        />
      </TopRow>
      <Content isVisible={isExpanded}>
        <ContentText>
          A confirmação do pagamento leva, em média, até 3 dias úteis. Depois
          desse prazo, o status do seu boleto é atualizado nos nossos canais.
        </ContentText>
      </Content>
    </Container>
  );
};

export default BillCompensationBanner;
